const CommentProcessCodeDesc =[
  //   this defines the reviewCodes   ---  reviewed By  --- review code --- Comment Reviews --- reviewCode
  { "value": "all",
    "selection": "Select all Review Codes"
  },
  {
    "value": 0,
    "selection": "No Review Information has been provided",
  },
  {
    "value": 1,
    "selection": "No Additional Action Required",
  },
  {
    "value": 2,
    "selection": "This Has Been Fixed",
  },
  {
    "value": 3,
    "selection": "Added to Near-Term App Changes",
  },
  {
    "value": 4,
    "selection": "Added to Mid-Term App Changes",
  },
  {
    "value": 5,
    "selection": "Added to Future (Long Term) List"
  },
  {
    "value": 6,
    "selection": "Added to Data Changes List"
  },
  {
    "value": 7,
    "selection": "Will Consider For Future Releases"
  },
  {
    "value": 8,
    "selection": "Discuss with Game Advisors"
  },
  { 
    "value": 9,
    "selection": "This Change Will Not Be Pursued",
  },
  { 
    "value": 99,
    "selection": "Review Code Not Yet Set",
  },
];

export default CommentProcessCodeDesc;
